<div class="flex flex-row w-full gap-6">
  <app-kiosk-language-flag-atom
    *ngFor="let language of languages$ | async as locales"
    [languageFlagUrl]="language.flagUrl"
    (click)="onChangeLanguage(language.locale, $event)"
  ></app-kiosk-language-flag-atom>
</div>
